// src/layouts/AdminSidebar.jsx
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Calendar,
  Ticket,
  Download,
  LogOut,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import "./admin-sidebar.scss";
import logoRTC from "../assets/img/gky-logo.png";

export default function AdminSidebar({ collapsed, onToggle }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    navigate("/login", { replace: true });
  };

  return (
    <aside className={`admin-sidebar${collapsed ? " collapsed" : ""}`}>
      {/* HEADER */}
      <div className="sidebar-header">
        <div className="brand">
          <img src={logoRTC} alt="RTC GKY" className="sidebar-logo" />
          <span>RTC GKY Admin</span>
        </div>
        <button
          className="sidebar-toggle"
          onClick={onToggle}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>

      {/* MENU */}
      <nav className="sidebar-menu">
        <NavItem to="/admin/dashboard" icon={<LayoutDashboard size={18} />} label="Dashboard" />
        <NavItem to="/admin/events" icon={<Calendar size={18} />} label="Events" />
        <NavItem to="/admin/bookings" icon={<Ticket size={18} />} label="Bookings" />
        <NavItem to="/admin/export" icon={<Download size={18} />} label="Export" />
      </nav>

      {/* FOOTER */}
      <div className="sidebar-footer">
        <button className="logout" onClick={handleLogout} title="Logout">
          <LogOut size={16} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

function NavItem({ to, icon, label }) {
  return (
    <NavLink
      to={to}
      title={label}
      className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}
